import React, {useState} from 'react';
import {Card} from "../../components/Card";
import {createInternationalizationPrefixer} from "../i18n/i18n";
import AjaxService from "../../platform/ajax/AjaxService";
import AuthenticationService from "../authentication/AuthenticationService";
import UBoldModal from "../../ubold-components/UBoldModal";

const t = createInternationalizationPrefixer("DeleteMyAccountPage");

export default function DeleteMyAccountPage() {

    const [confirmed, setConfirmed] = useState(false);
    const [confirming, setConfirming] = useState(false);
    const [failed, setFailed] = useState(false);

    const confirmDelete = () => {
        setFailed(false);
        AjaxService.delete("/api/user-account/self")
            .then(response => {
                if (response.ok) {
                    // No manual redirect: flipping auth state re-renders the router into the
                    // unauthenticated branch, whose catch-all navigates to /sign-in.
                    AuthenticationService.deAuthenticate();
                } else {
                    handleFailure();
                }
            })
            .catch(handleFailure);
    };

    const handleFailure = () => {
        setConfirming(false);
        setFailed(true);
    };

    const explanation = <p>{t("Usunięcie konta jest trwałe. Wszystkie Twoje dane osobowe zostaną usunięte, a w systemie pozostanie jedynie zanonimizowany wpis audytowy (data usunięcia oraz zamaskowany adres e-mail).")}</p>;

    const dangerAlert = <div className="alert alert-danger">
        <i className="fas fa-exclamation-triangle"/> {t("Ta operacja jest nieodwracalna. Twoje konto zostanie TRWALE usunięte.")}
    </div>;

    const failureAlert = <div className="alert alert-warning">{t("Nie udało się usunąć konta. Spróbuj ponownie później.")}</div>;

    const confirmationCheckbox = <div className="form-check mb-3">
        <input className="form-check-input" type="checkbox" id="confirm-delete-account" checked={confirmed}
               onChange={(e: React.ChangeEvent<HTMLInputElement>) => setConfirmed(e.target.checked)}/>
        <label className="form-check-label" htmlFor="confirm-delete-account">{t("Tak, chcę trwale usunąć swoje konto")}</label>
    </div>;

    const submitButton = <button className="btn btn-danger" disabled={!confirmed} onClick={() => setConfirming(true)}>
        {t("Usuń moje konto")}
    </button>;

    const confirmationModal = <UBoldModal opened={confirming} onClose={() => setConfirming(false)}
                                          header={t("Twoje konto zostanie teraz usunięte i zostaniesz wylogowany.")}>
        <div className="text-center">
            <button className="btn btn-danger mr-2" onClick={confirmDelete}>{t("Usuń i wyloguj")}</button>
            <button className="btn btn-secondary" onClick={() => setConfirming(false)}>{t("Anuluj")}</button>
        </div>
    </UBoldModal>;

    return <Card header={t("Usuń konto")} additionalClassNames="mt-4">
        {explanation}
        {dangerAlert}
        {failed && failureAlert}
        {confirmationCheckbox}
        {submitButton}
        {confirmationModal}
    </Card>;
}
